// Central registry of available email section components

const EmailSectionRegistry = {
  // Header components
  'header': {
    id: 'header',
    type: 'Header',
    title: 'Email Header',
    image: '/header.png',
    description: 'Add a header with logo and navigation links',
    component: 'Header',
    category: 'header',
    isUnique: true
  },
  
  // Banner components
  'banner': {
    id: 'banner',
    type: 'Banner',
    title: 'Banner',
    image: '/banner-placeholder.png',
    description: 'Add a banner with background image and text overlay',
    component: 'Banner',
    category: 'content',
    isUnique: false
  },
  'img-circle': {
    id: 'img-circle',
    type: 'Img_circle',
    title: 'Circular Image',
    image: '/banner-placeholder.png',
    description: 'Centered circular image (supports image_placeholder from API)',
    component: 'Img_circle',
    category: 'content',
    isUnique: false
  },
  
  // Content sections with standardized props
  'left-image-with-button': {
    id: 'left-image-with-button',
    type: 'Left_Image_Right_Title_Desc_Btn',
    title: 'Left Image with Content',
    image: '/left-image.jpg',
    description: 'Image on the left with text and optional button on the right',
    component: 'LeftImageRightContent',
    category: 'content',
    isUnique: false
  },
  'right-image-with-button': {
    id: 'right-image-with-button',
    type: 'Right_Image_Left_Title_Desc_Btn',
    title: 'Right Image with Content',
    image: '/right-image.jpg',
    description: 'Image on the right with text and optional button on the left',
    component: 'RightImageLeftContent',
    category: 'content',
    isUnique: false
  },
  'title-description': {
    id: 'title-description',
    type: 'H1_H2_Desc',
    title: 'Title with Description',
    image: '/title-desc.png',
    description: 'Heading with description and optional button',
    component: 'TitleDescription',
    category: 'content',
    isUnique: false
  },
  'title-4img': {
    id: 'title-4img',
    type: 'Title_4Img',
    title: 'Title with 4 Images',
    image: '/title-desc.png',
    description: 'Title with 4 images in a 2x2 grid layout, each with text below',
    component: 'Title_4Img',
    category: 'content',
    isUnique: false
  },
  'description-btn': {
    id: 'description-btn',
    type: 'Description_btn',
    title: 'Centered Button',
    image: '/button.png',
    description: 'Only one centered CTA button',
    component: 'Description_btn',
    category: 'content',
    isUnique: false
  },
  '2col-3rows-benefits': {
    id: '2col-3rows-benefits',
    type: '2COL_3ROWS_Benefits',
    title: '2 Column 3 Rows Benefits',
    image: '/title-desc.png',
    description: 'Title, description, and 3 product rows with alternating image positions',
    component: '2COL_3ROWS_Benefits',
    category: 'content',
    isUnique: false
  },
  'offer-details-h1-desc': {
    id: 'offer-details-h1-desc',
    type: 'OfferDetails_H1_Desc',
    title: 'Offer Details with Button',
    image: '/title-desc.png',
    description: 'Description text with a left-aligned call-to-action button below',
    component: 'OfferDetails_H1_Desc',
    category: 'content',
    isUnique: false
  },
  'offer-details-desc-3': {
    id: 'offer-details-desc-3',
    type: 'OfferDetails_Desc_3',
    title: 'Offer Details with Promo Code',
    image: '/title-desc.png',
    description: 'Introductory message, prominent promo code, urgency message, CTA button, closing text, signature, and postscript',
    component: 'OfferDetails_Desc_3',
    category: 'content',
    isUnique: false
  },
  'button': {
    id: 'button',
    type: 'Button',
    title: 'Call to Action Button',
    image: '/button.png',
    description: 'Add a standalone call to action button',
    component: 'Button',
    category: 'interactive',
    isUnique: false
  },
  'faq-generic': {
    id: 'faq-generic',
    type: 'faq_generic',
    title: 'FAQ Section',
    image: '/faq.svg',
    description: 'Collapsible frequently asked questions section with expandable answers',
    component: 'faq_generic',
    category: 'content',
    isUnique: false
  },
  'ecom-ingredients': {
    id: 'ecom-ingredients',
    type: 'ecom_ingredients',
    title: 'E-commerce Ingredients',
    image: '/ingredients.svg',
    description: 'Carousel of ingredient cards with icons, descriptions, and nutrition benefits',
    component: 'ecom_ingredients',
    category: 'content',
    isUnique: false
  },
  '2col': {
    id: '2col',
    type: '2Col',
    title: 'Two Column Layout',
    image: '/title-desc.png',
    description: 'Simple two-column layout with text content and image',
    component: '2Col',
    category: 'content',
    isUnique: false
  },
  '3col-1img-center': {
    id: '3col-1img-center',
    type: '3Col_1Img_center',
    title: 'Three Column Center Image',
    image: '/title-desc.png',
    description: 'Three-column layout with center image and content blocks on sides',
    component: '3Col_1Img_center',
    category: 'content',
    isUnique: false
  },
  '4col-4img-title-price': {
    id: '4col-4img-title-price',
    type: '4Col_4Img_Title_price',
    title: '4 Column Product Grid',
    image: '/title-desc.png',
    description: '2x2 grid of product cards with images, titles, and prices',
    component: '4Col_4Img_Title_price',
    category: 'content',
    isUnique: false
  },
  '3col-3img': {
    id: '3col-3img',
    type: '3Col_3Img',
    title: '3 Column with 3 Images',
    image: '/title-desc.png',
    description: 'Three columns with circular images and text labels below each',
    component: '3Col_3Img',
    category: 'content',
    isUnique: false
  },
  '4col-1img-left': {
    id: '4col-1img-left',
    type: '4Col_1Img_left',
    title: 'Cart Item',
    image: '/title-desc.png',
    description: 'Cart item with image on left and product details (name, quantity, price) on right',
    component: '4Col_1Img_left',
    category: 'content',
    isUnique: false
  },
  'h1-align-right-desc': {
    id: 'h1-align-right-desc',
    type: 'H1_AlignRight_Desc',
    title: 'Right-Aligned Heading & Description',
    image: '/title-desc.png',
    description: 'Heading and description text aligned to the right with automatic link detection',
    component: 'H1_AlignRight_Desc',
    category: 'content',
    isUnique: false
  },
  'header-title-desc': {
    id: 'header-title-desc',
    type: 'Header_Title_Desc',
    title: 'Header with Title & Description',
    image: '/header.png',
    description: 'Header section with main heading, subtitle, description, and optional CTA button',
    component: 'Header_Title_Desc',
    category: 'header',
    isUnique: false
  },
  'h1-desc-4': {
    id: 'h1-desc-4',
    type: 'H1_Desc_4',
    title: 'Heading with 4 Paragraphs',
    image: '/title-desc.png',
    description: 'Centered heading with multiple description paragraphs separated by dividers',
    component: 'H1_Desc_4',
    category: 'content',
    isUnique: false
  },
  'h1-desc-5': {
    id: 'h1-desc-5',
    type: 'H1_Desc_5',
    title: 'Heading with Coupon Code',
    image: '/title-desc.png',
    description: 'Heading with description, coupon code block, CTA button, and closing signature',
    component: 'H1_Desc_5',
    category: 'content',
    isUnique: false
  },
  'h1-desc-6': {
    id: 'h1-desc-6',
    type: 'H1_Desc_6',
    title: 'Heading with Coupon Code & Two Buttons',
    image: '/title-desc.png',
    description: 'Heading with description, dashed coupon code block, two CTA buttons, inspirational message, and closing text',
    component: 'H1_Desc_6',
    category: 'content',
    isUnique: false
  },
  'h1-h2-desc-4': {
    id: 'h1-h2-desc-4',
    type: 'H1_H2_Desc_4',
    title: 'H1 & H2 Heading with Coupon Code',
    image: '/title-desc.png',
    description: 'Greeting, H1 heading, H2 subheading (optional), description paragraphs, discount offer with dashed coupon code block, CTA button, and closing signature',
    component: 'H1_H2_Desc_4',
    category: 'content',
    isUnique: false
  },
  
  // Footer components
  'footer': {
    id: 'footer',
    type: 'Footer',
    title: 'Email Footer',
    image: '/footer.png',
    description: 'Add a footer with social links and copyright information',
    component: 'Footer',
    category: 'footer',
    isUnique: true
  }
};

// Get all available sections
export const getAllSections = () => {
  return Object.values(EmailSectionRegistry);
};

// Get sections by category
export const getSectionsByType = (category) => {
  return Object.values(EmailSectionRegistry)
    .filter(section => section.category === category);
};

// Get section by ID
export const getSectionById = (id) => {
  return EmailSectionRegistry[id] || null;
};

// Check if section exists
export const sectionExists = (id) => {
  return !!EmailSectionRegistry[id];
};

export default EmailSectionRegistry; 